<div class="chd-dialog">
  <div class="lm-dialog-header">
    <h2 class="lm-dialog-title">{{ isEditMode ? 'Edit Holiday' : 'Create New Holiday' }}</h2>
    <button class="lm-dialog-close-btn" (click)="onCancel()" [attr.aria-label]="'leave_management.create_holiday_dialog.aria_label.close' | transloco">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill="#D92D20"/>
        <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="lm-dialog-divider"></div>

  <div class="lm-dialog-body">
    <form [formGroup]="form">
      <div class="lm-dialog-row-two">
        <div class="lm-form-group">
          <label class="lm-field-label">Enter Holiday Name <span class="lm-req">*</span></label>
          <mat-form-field appearance="outline" class="lm-full-width">
            <input matInput formControlName="name" [placeholder]="'leave_management.create_holiday_dialog.placeholder.new_years_day' | transloco" />
          </mat-form-field>
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
          <div class="lm-dialog-error">
            {{ 'leave_management.create_holiday_dialog.holiday_name_is_required' | transloco }}
          </div>
          }
        </div>

        <div class="lm-form-group">
          <label class="lm-field-label">Holiday Date <span class="lm-req">*</span></label>
          <mat-form-field appearance="outline" class="lm-full-width">
            <input matInput [matDatepicker]="datePicker" formControlName="date"
                   placeholder="DD-MM-YYYY" readonly />
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
          @if (form.get('date')?.invalid && form.get('date')?.touched) {
          <div class="lm-dialog-error">
            {{ 'leave_management.create_holiday_dialog.holiday_date_is_required' | transloco }}
          </div>
          }
        </div>
      </div>

      <div class="chd-toggle-row">
        <mat-slide-toggle formControlName="isOptional" color="primary">
          {{ 'leave_management.create_holiday_dialog.optional_holiday' | transloco }}
        </mat-slide-toggle>
      </div>

      <div class="chd-section-label">Applicable Location <span class="lm-req">*</span></div>

      <div class="lm-dialog-row-two">
        <div class="lm-form-group">
          <label class="lm-field-label">{{ 'leave_management.create_holiday_dialog.country' | transloco }}</label>
          <lib-ers-searchable-select
            formControlName="countryId"
            [options]="countries"
            optionValue="id"
            optionLabel="country"
            placeholder="{{ loadingCountries ? 'Loading...' : 'Select Country' }}"
          ></lib-ers-searchable-select>
        </div>
        <div class="lm-form-group">
          <label class="lm-field-label">{{ 'leave_management.create_holiday_dialog.state' | transloco }}</label>
          <lib-ers-searchable-select
            formControlName="stateId"
            [options]="states"
            optionValue="id"
            optionLabel="stateName"
            placeholder="{{ loadingStates ? 'Loading...' : (form.get('countryId')?.value ? 'Select State' : 'Select country first') }}"
          ></lib-ers-searchable-select>
        </div>
      </div>

      <div class="lm-form-group chd-notes-group">
        <label class="lm-field-label">Add Notes (Optional)</label>
        <mat-form-field appearance="outline" class="lm-full-width">
          <textarea matInput formControlName="notes" rows="4"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="lm-dialog-footer">
    <button class="lm-btn lm-btn--reset" type="button" (click)="onReset()">{{ 'leave_management.create_holiday_dialog.reset' | transloco }}</button>
    <button class="lm-btn lm-btn--primary" type="button" [disabled]="form.invalid" (click)="onSubmit()">
      {{ isEditMode ? 'Save' : 'Create' }}
    </button>
  </div>
</div>